import React from 'react';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import { HELP_PAGE_TITLE } from '../../constants/confluenceConstants';
import '../../css/confluence.css';

const Help = () => {
  return <ConfluencePage pageName={HELP_PAGE_TITLE} />;
};

export default Help;
